import { createOnOffRow } from './createOnOffRow';
import { createQuantityRow } from './createQuantityRow';
import {
  Allocation,
  SerializedComponent,
  AllocationsError,
} from '../../../machines';
import { ComponentPreview } from '../types';

type ComponentsRow = {
  onOff: ComponentPreview[];
  quantity: ComponentPreview[];
};

type ComponentsPreviewRow = {
  recurring: ComponentsRow;
  oneTime: Pick<ComponentsRow, 'quantity'>;
};

export const createComponentsPreviewRow = (
  components: SerializedComponent[],
  onUpdateAllocation: (allocation: Allocation) => void,
  locale: string,
  errors?: AllocationsError[]
) => {
  const rows: ComponentsPreviewRow = {
    recurring: {
      onOff: [],
      quantity: [],
    },
    oneTime: {
      quantity: [],
    },
  };

  for (const component of components) {
    if (component.type === 'quantity') {
      const hasError =
        errors?.findIndex((error) => error.id === component.id) > -1;
      const row = createQuantityRow(
        component,
        onUpdateAllocation,
        locale,
        hasError
      );
      if (component.recurring) {
        rows.recurring.quantity.push(row);
      } else {
        rows.oneTime.quantity.push(row);
      }
    }

    if (component.type === 'on_off') {
      const row = createOnOffRow(component, onUpdateAllocation, locale);
      if (component.recurring) {
        rows.recurring['onOff'].push(row);
      }
    }
  }

  return rows;
};
